import 'foundation-sites/dist/css/foundation.min.css';
import 'foundation-sites/dist/js/foundation.min.js';

import "./Header.css"
import RequestForm from "../RequestForm/RequestForm";

const Header = () => (
    <header className="Header greenBackground">
        <div className="grid-container full ">
            <div className="grid-container">
                <div className="grid-x grid-margin-x" id="container">
                    <div className="cell small-12 medium-6 large-6">
                        <img width="200" src="/public/credit/assets/img/farabi-logo.png"/>
                        <h1 className="iransans color-white">یک میلیارد اعتبار رایگان!</h1>
                        <p className="iransans color-white text-justify margin-2">
                            در طرح جدید اعتبار کارگزاری فارابی می‌توانید در بدو ورود، بدون نیاز به چک تضمین و هزینه مالی
                            تا یک میلیارد تومان اعتبار رایگان یک ماهه دریافت کنید. برای دریافت اعتبار همین حالا درخواست
                            خود را ثبت کنید.
                        </p>
                        <RequestForm />
                    </div>

                    <div className="cell small-12 medium-6 large-6 text-center">
                        <img className="float keyboard-icon" src="/assets/img/calc.png"/>
                    </div>
                </div>
            </div>
        </div>
    </header>);

export default Header;